import { type EmojiId, type OrganizationKey, type ResourceId } from '../common/structs';

export const organizations = () => ({
    collection: () => `/organizations`,
    single: (id: ResourceId) => `/organizations/${id}`,
    emoji: (id: ResourceId) => ({
        collection: () => `/organizations/${id}/emoji`,
        tags: (eid: EmojiId) => ({
            collection: () => `/organizations/${id}/emoji/${eid}/tags`,
        }),
    }),
    branding: (key: OrganizationKey) => `/organizations/${key}/branding`,
    users: () => ({
        collection: (id: ResourceId) => `/organizations/${id}/users`,
    }),
});
